/* global MEDIA_ROOT, __CLIENT__ */
import React, { PropTypes } from 'react';

import { breakpointMD } from '../../../base-styles/vars';

const Video = ({ reliveId }) => {
  const desktop = __CLIENT__ && !!window.matchMedia(`(min-width: ${breakpointMD})`).matches;
  return (
    <video
      id="relive-video"
      onClick={() => document.getElementById('relive-video').play()}
      controls
      src={reliveId}
      type="video/mp4"
      poster={desktop ? `${MEDIA_ROOT}/images/relive_holdingimg.png` : `${MEDIA_ROOT}/images/coursemap_noplaybuttn.png`} 
    />
  );
};

Video.propTypes = {
  reliveId: PropTypes.string.isRequired,
};

export default Video;




// WEBPACK FOOTER //
// ./app/src/components/EventDetail/Video/index.jsx